import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const BookPage = lazy(() => import('../pages/book/page'));
const AppointmentPage = lazy(() => import('../pages/appointment/page'));
const LoadingAppointmentPage = lazy(() => import('../pages/loading/page'));
const ForwardingAppointmentPage = lazy(() => import('../pages/forwarding/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>,
  },
  {
    path: '/',
    element: <ProtectedRoute><HomePage /></ProtectedRoute>,
  },
  {
    path: '/about',
    element: <ProtectedRoute><AboutPage /></ProtectedRoute>,
  },
  {
    path: '/services',
    element: <ProtectedRoute><ServicesPage /></ProtectedRoute>,
  },
  {
    path: '/book',
    element: <ProtectedRoute><BookPage /></ProtectedRoute>,
  },
  {
    path: '/appointment',
    element: <ProtectedRoute><AppointmentPage /></ProtectedRoute>,
  },
  {
    path: '/loading-appointment',
    element: <ProtectedRoute><LoadingAppointmentPage /></ProtectedRoute>,
  },
  {
    path: '/forwarding-appointment',
    element: <ProtectedRoute><ForwardingAppointmentPage /></ProtectedRoute>,
  },
  {
    path: '/profile',
    element: <ProtectedRoute><ProfilePage /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
